export enum RecoilAtomKeys {
  GLOBAL_LOADING = 'globlaLoading',
}
